<div class="junior-camps" *ngIf="juniorCamps$ | async as juniorCamps">
  <lx-price-lists-portal-price-list-panel
    [priceListFilters]="filters$ | async"
    [withData]="juniorCamps?.camps?.length > 0"
    (filtersChanged)="filterJuniorCamps($event)"
  >
    <lx-price-lists-portal-junior-camps-price-list-data [camps]="juniorCamps.camps" [applicationForms]="applicationForm">
    </lx-price-lists-portal-junior-camps-price-list-data>
  </lx-price-lists-portal-price-list-panel>
</div>
